import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import fetch from './../../fetch';
import { baseUrl, indianProjectsBaseURL } from '../../../../Containers/Config/index.js';
import { LOGIN, LOGIN_SUCCESS, LOGIN_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import cogoToast from 'cogo-toast';

function* userLogin({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${indianProjectsBaseURL}/login`,
      method: 'POST',
      data: payload?.data,
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (response.status === 200) {
      yield put({ type: LOGIN_SUCCESS, payload: response });
    } else {
      // cogoToast.error(response?.response?.data?.message);
      yield put({ type: LOGIN_ERROR, payload: response?.data?.message });
    }
  } catch (error) {
    yield put({ type: LOGIN_ERROR, payload: error });
  }
}

export function* watchUserLogin() {
  yield takeEvery(LOGIN, userLogin);
}

function* userLoginSaga() {
  yield all([fork(watchUserLogin)]);
}

export default userLoginSaga;
